export default __webpack_public_path__ + "static/media/trashYellowIcon.90ebd9bf.svg";